// Configuration constants for playlists query

// Time intervals
export const BUFFER_TIME_MS = 100; // Buffer to ensure we're past the program start time
export const SOON_THRESHOLD_MS = 10000; // Threshold for determining when a future event is coming soon (10 seconds)
export const MIN_INVALIDATION_INTERVAL = 10000; // 10 seconds minimum between invalidations
// When using target time tracking, this becomes less important as we rely more on
// whether the target time is still in the future. However, we still need a reasonable
// limit for non-target time cases or when target time has passed.
export const INTERVAL_REUSE_MAX_AGE = 600000; // Maximum age for reusing calculated intervals (10 minutes)

// Throttling and backoff settings
export const BACKOFF_TIMES = [5, 10, 30, 60, 5 * 60, 10 * 60] as const; // in seconds
export const DEFAULT_REFETCH_INTERVAL = BACKOFF_TIMES[0] * 1000; // Default interval when no specific time available
export const MAX_TIMESTAMP_CALCULATIONS_PER_INTERVAL = 20; // Limit calculations to prevent excessive CPU usage
export const MAX_THROTTLED_INTERVAL = 30000; // Maximum throttled interval (30 seconds)
export const MIN_THROTTLED_INTERVAL = 10000; // Minimum throttled interval (10 seconds)
export const UNCHANGED_FETCHES_BEFORE_THROTTLING = 10; // Number of unchanged fetches before throttling kicks in

// Logging settings
export const CONSECUTIVE_FETCH_LOG_INTERVAL = 5; // Log every N consecutive unchanged fetches
export const THROTTLING_LOG_INTERVAL = 10; // Log throttling details every N throttled fetches
export const REFRESH_LOG_MIN_INTERVAL_MS = 30000; // Minimum time between general refresh logs
export const REUSE_LOG_MIN_INTERVAL_MS = 5000; // Minimum time between reuse interval logs

// Logging system
export const DEBUG = false;
export const LOG_PREFIX = '📺 PlaylistsQuery:';

// Priority refresh configuration
export const RECENT_PAST_THRESHOLD_MS = 5 * 60 * 1000; // 5 minutes
export const QUICK_REFRESH_MAX_MS = 10000; // 10 seconds max for quick refresh
